import { BodyTextContainer, ContentContainer, Heading } from '@msaf/core-react'
import { MenuLinks } from '../../../../../constants'

export default function PermissionDenied() {
  return (
    <ContentContainer>
      <BodyTextContainer>
        <Heading level={1}>Permission denied</Heading>
        <p>You do not have the required permissions to access this page or perform some actions on this page.</p>
        <p>This can be due to the information you are trying to access not being published yet.</p>
        <p>
          Please <a href={MenuLinks.CONTACT_US}>contact us</a> if you think you should have the required permissions on
          this page.
        </p>
      </BodyTextContainer>
    </ContentContainer>
  )
}
